import { FadedImage } from "../../FadedImage";

const A = "/brand";
const IMG = `${A}/blueprint4joy-books-floor-peeking-pages.jpg`;
const ALT = "Lara sitting cross-legged on the floor surrounded by scattered manuscript pages, peeking over a handful of them.";

export function CurrentlyOnMyFloor() {
  return (
    <section data-testid="books-currently-on-floor" className="relative overflow-hidden bg-[#FAFAF8]">
      <div className="relative w-full overflow-hidden reveal pb-10 lg:pb-0">
        {/* Desktop image half-band, left side */}
        <div className="hidden lg:block absolute inset-y-0 left-0 w-[48%]">
          <FadedImage
            src={IMG}
            alt={ALT}
            testId="books-currently-on-floor-image"
            bg="#FAFAF8"
            objectPosition="50% 11%"
            featherRight={60}
            featherTop={10}
            featherBottom={10}
            fadeOpacity={0.5}
            className="absolute inset-0"
          />
        </div>

        {/* Mobile image stacked on top */}
        <div className="lg:hidden relative w-full aspect-[4/5] mt-2">
          <FadedImage
            src={IMG}
            alt={ALT}
            testId="books-currently-on-floor-image-mobile"
            bg="#FAFAF8"
            objectPosition="50% 45%"
            featherBottom={20}
            className="absolute inset-0"
          />
        </div>

        {/* Text on the clean right */}
        <div className="relative z-[2] max-w-7xl mx-auto px-6 md:px-10 pt-8 lg:pt-0 flex items-center justify-end lg:min-h-[520px]">
          <div className="w-full lg:w-[52%]">
            <div className="max-w-[566px] lg:ml-auto">
              <h2
                data-testid="books-currently-on-floor-header"
                className="font-display text-[34px] md:text-[44px] text-[#1C1917] leading-[1.15] mb-[8px]"
              >
                Currently on My Floor
              </h2>
              <div className="space-y-4 text-lg md:text-xl leading-relaxed text-[#57534E]">
                <p>Not every story is ready for a cover.</p>
                <p>
                  Some are still covered in handwritten notes, crossed-out
                  paragraphs and questions I haven&rsquo;t answered yet.
                </p>
                <p>
                  Those pages are spread across my floor, tucked into
                  notebooks and riding around in my car until I figure out
                  what they&rsquo;re trying to become.
                </p>
                <p>They&rsquo;re not finished.</p>
                <p className="italic">They&rsquo;re becoming.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
